// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/itemPage.styl
// module id = 445
// module chunks = 0